import FastImage from 'react-native-fast-image';
import {ScrollView} from 'react-native-gesture-handler';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import {Platform} from 'react-native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
  
`;

export const Header = styled.View`
  height: ${RFPercentage(24)}px;
  background-color: ${({theme}) => theme.colors.red_light};
  justify-content: flex-end;
`;

export const HeaderContent = styled(FastImage)`
  width: 100%;
  height: 100%;
  
`;

export const Content = styled.View`
  flex: 1;
  margin-top: -${RFValue(30)}px;
  
`;

export const IconContainer = styled.View`
  width: ${RFValue(68)}px;
  height: ${RFValue(68)}px;
  background-color: ${({theme}) => theme.colors.background};
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(12)}px;
  border-radius: ${RFValue(16)}px;
`;

export const Logo = styled(FastImage)`
  font-size: ${RFValue(30)}px;
  color: ${({theme}) => theme.colors.red};
  width: ${RFValue(60)}px;
  height: ${RFValue(60)}px;
`;

export const Title = styled.Text`
  text-align: center;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(18)}px;
  margin-bottom: ${RFValue(12)}px;
  text-transform: capitalize;
`;

export const ContentHeader = styled.View`
  
  align-items: center;
  margin: 0 -24px;
  padding: 0 24px;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border2};
  margin-bottom: ${RFValue(12)}px;
  justify-content: center;
`;

export const InfoText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;

  text-align: center;

  text-transform: capitalize;
`;

export const ContentScroll = styled(ScrollView)`
  flex: 1;
`;

export const Section = styled.View`
  width: 100%;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border2};
  margin-bottom: ${RFValue(12)}px;
  padding-bottom: ${RFValue(12)}px;
  padding: 0 24px;
  
`;

export const SectionHeader = styled.View`
  flex-direction: row;
  align-items: center;

  justify-content: space-between;
`;

export const SectionTitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const SectionContent = styled.View`
`;

export const Footer = styled.View`
  padding: 0 24px;
  margin-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;
